import RequsetApI from '@/js/request/requsetApI';
import GmxGlobal from '@/js/global';

const state = {
  currentVersion: '',
  versionContent: '',
};

const mutations = {
  SET_CURRENT_VERSION(state, version) {
    state.currentVersion = version;
  },
  SET_VERSION_CONTENT(state, content) {
    state.versionContent = content;
  },
};

const actions = {
  async loadVersionInfo({ commit }) {
    commit('SET_LOADING', true);
    try {
      const res = await new Promise((resolve) => {
        RequsetApI.selectCommonInfo(GmxGlobal.SERVICE_CODE_VERSION, { useYn: 'Y' }, resolve);
      });
      
      if (res.data.results && res.data.results.length > 0) {
        const latestVersion = res.data.results[0];
        commit('SET_CURRENT_VERSION', latestVersion.verId);
        commit('SET_VERSION_CONTENT', latestVersion.verContent);
      }
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  currentVersion: state => state.currentVersion,
  versionContent: state => state.versionContent,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 